//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '@/plugins/filters'

const TOP_PAGE_URL = 'https://client.officedeyasai.jp/'

export default {
  name: 'RequestPeriodClosed',

  props: {
    // 見出し文言（プラン・種別名）
    title: {
      type: String,
      required: true,
    },
    // 次回注文可能期間の開始日（YYYY-MM-DD等）。取得できない場合はnull
    nextStartDate: {
      type: String,
      default: null,
    },
    // 次回注文可能期間の終了日。取得できない場合はnull
    nextEndDate: {
      type: String,
      default: null,
    },
  },

  computed: {
    periodMessage() {
      if (!this.nextStartDate || !this.nextEndDate) {
        return '次回お届け分のご注文期間は、現在準備中です。'
      }

      const start = formatDate(this.nextStartDate, 'M月d日(EEEEE)')
      const end = formatDate(this.nextEndDate, 'M月d日(EEEEE)')

      return `次回お届け分の商品は、${start}〜${end}にご注文いただけます。`
    },
  },

  methods: {
    goToTop() {
      window.location.href = TOP_PAGE_URL
    },
  },
}
